import _get from 'lodash.get';
import resolveProfileImages from './resolveProfileImages';


export default async function getMembers(
collaborators = [],
organisationId,
apiClient)
{
  const userAndTeams = collaborators.filter(({ user, team }) => user || team);

  const members = userAndTeams.
  map(({
    user,
    team,
    role,
    resourceRoleAssignmentId
  }) => user ?
  { ...user, role, resourceRoleAssignmentId } :
  { ...team, role, resourceRoleAssignmentId, membersCount: _get(team, 'members.length', 0) }
  );

  const membersWithProfileImages = await resolveProfileImages(members, organisationId, apiClient);

  const ownerIndex = membersWithProfileImages.
  findIndex(({ userId, role }) => userId && role && role.name === 'OWNER');

  if (ownerIndex === -1) {return membersWithProfileImages;}

  // move owner to the first member poistion
  const owner = membersWithProfileImages.splice(ownerIndex, 1)[0];
  membersWithProfileImages.splice(0, 0, owner);

  return membersWithProfileImages;
}